import * as THREE from 'three';
import { createNoise2D } from 'simplex-noise';
import { WIND } from '../core/SimConfig.js';

export default class WindManager {
  constructor() {
    this._noiseX = createNoise2D();
    this._noiseY = createNoise2D();
    this._noiseZ = createNoise2D();
    this._t = 0;

    this._base = new THREE.Vector3();
    this._gust = 0;
    this.wind = new THREE.Vector3();

    this.setPreset(WIND.defaultPreset);
  }

  /** Select a named wind preset (see WIND.presets). Unknown names fall back to the default. */
  setPreset(name) {
    const preset = WIND.presets[name] || WIND.presets[WIND.defaultPreset];
    this._base.set(...preset.base);
    this._gust = preset.gust;
    this.wind.copy(this._base);
  }

  update(dt) {
    this._t += dt;
    const t = this._t * WIND.gustFrequency;

    this.wind.set(
      this._base.x + this._noiseX(t, 0) * this._gust,
      this._base.y + this._noiseY(t, 0) * this._gust * WIND.verticalScale,
      this._base.z + this._noiseZ(t, 0) * this._gust,
    );
  }
}
